<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
  <p *ngFor="let msg of data.confirmMessages">{{msg}}</p>
</div>
